import React, { useState } from 'react';
import {
  BuildingOfficeIcon,
  CubeIcon,
  ArchiveBoxIcon,
  DocumentTextIcon,
  TagIcon,
} from '@heroicons/react/24/outline';
import WarehouseManagement from './WarehouseManagement';
import ProductManagement from './ProductManagement';
import InventoryItems from './InventoryItems';
import InventoryLots from './InventoryLots';
import SupplierOffers from './SupplierOffers';
import { Tabs } from '../ui';

type Tab = 'warehouses' | 'products' | 'lots' | 'items' | 'offers';

const InventoryManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('warehouses');

  const tabs = [
    { id: 'warehouses' as Tab, label: 'Warehouses', icon: <BuildingOfficeIcon className="h-5 w-5" /> },
    { id: 'products' as Tab, label: 'Products', icon: <CubeIcon className="h-5 w-5" /> },
    { id: 'lots' as Tab, label: 'Lots', icon: <TagIcon className="h-5 w-5" /> },
    { id: 'items' as Tab, label: 'Inventory Items', icon: <ArchiveBoxIcon className="h-5 w-5" /> },
    { id: 'offers' as Tab, label: 'Supplier Offers', icon: <DocumentTextIcon className="h-5 w-5" /> },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-tour="page-content">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-neutral-900">Inventory Management</h1>
        <p className="mt-2 text-sm text-neutral-600">
          Manage warehouses, products, inventory items, and supplier offers
        </p>
      </div>

      {/* Tabs */}
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onChange={(id) => setActiveTab(id as Tab)}
        className="mb-6"
      />

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === 'warehouses' && <WarehouseManagement />}
        {activeTab === 'products' && <ProductManagement />}
        {activeTab === 'lots' && <InventoryLots />}
        {activeTab === 'items' && <InventoryItems />}
        {activeTab === 'offers' && <SupplierOffers />}
      </div>
    </div>
  );
};

export default InventoryManagement;
